
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { memo } from "react";

interface LineChartDataItem {
  name: string;
  value: number;
}

interface YearlyGrowthChartProps {
  data: LineChartDataItem[];
}

// Memoized component to prevent unnecessary re-renders
const YearlyGrowthChart = memo(({ data }: YearlyGrowthChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Yearly Growth</CardTitle>
        <CardDescription>Total analyses performed</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Line 
                type="monotone" 
                dataKey="value" 
                stroke="#0EA5E9" 
                strokeWidth={2} 
                isAnimationActive={false} // Disable animations for better performance
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
});

YearlyGrowthChart.displayName = "YearlyGrowthChart";

export default YearlyGrowthChart;
